export default "__VITE_ASSET__TuV6p0s1__"